import { localize } from '@deriv/translations';

export const CFD_TEXT = {
    dxtrade: () => localize('Deriv X'),
    mt5: () => localize('MT5'),
    mt5_cfds: () => localize('MT5 CFDs'),
    ctrader: () => localize('Deriv cTrader'),
    cfd: () => localize('CFDs'),
    synthetic: () => localize('Standard'),
    synthetic_demo: () => localize('Standard Demo'),
    synthetic_bvi: () => localize('Standard BVI'),
    synthetic_svg: () => localize('Standard SVG'),
    synthetic_v: () => localize('Standard Vanuatu'),
    financial: () => localize('Financial'),
    financial_demo: () => localize('Financial Demo'),
    financial_bvi: () => localize('Financial BVI'),
    stp: () => localize('Financial Labuan'),
    financial_v: () => localize('Financial Vanuatu'),
    financial_svg: () => localize('Financial SVG'),
    all_swap_free_demo: () => localize('Swap-Free Demo'),
    all_zero_spread_demo: () => localize('Zero Spread Demo'),
    all_swap_free_svg: () => localize('Swap-Free SVG'),
    all_zero_spread_bvi: () => localize('Zero Spread BVI'),
    gold: () => localize('Gold'),
    gold_bvi: () => localize('Gold BVI'),
    gold_v: () => localize('Gold Vanuatu'),
    gold_dml: () => localize('Gold DML'),
};
